(() => {
  if (window.EmslandrostStorefront) return;
  const anchorId = 'em-widerruf-formular';
  let observer;
  const scrollToForm = () => {
    if (window.location.hash !== `#${anchorId}`) return;
    const anchor = document.getElementById(anchorId);
    if (!anchor) return;
    anchor.scrollIntoView({ block: 'start', behavior: 'auto' });
    anchor.focus({ preventScroll: true });
  };
  const locateForm = () => {
    const frame = document.querySelector('main iframe[id^="wf-iframe-"][title="Withdrawal Form"]');
    if (!frame) return false;
    const wrapper = frame.closest('.shopify-app-block') || frame.parentElement;
    if (!document.getElementById(anchorId)) {
      const anchor = document.createElement('div');
      anchor.id = anchorId;
      anchor.tabIndex = -1;
      wrapper.before(anchor);
    }
    observer?.disconnect();
    scrollToForm();
    return true;
  };
  const init = () => {
    if (!window.location.pathname.endsWith('/pages/widerruf-formular')) return;
    if (!locateForm()) {
      const main = document.querySelector('main');
      if (!main) return;
      observer?.disconnect();
      observer = new MutationObserver(locateForm);
      observer.observe(main, { childList: true, subtree: true });
    }
  };
  window.EmslandrostStorefront = { init };
  window.addEventListener('hashchange', scrollToForm);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
